import { Component, OnInit } from '@angular/core';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-usertabs',
    templateUrl: './user-tabs.component.html',
    styleUrls: ['./user-tabs.component.scss'],
    standalone: false
})
export class UserTabsComponent implements OnInit {
  public routes: object[];

  public isSelected = false;
  public isResponsive: boolean;

  constructor(
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: 'Datos', link: '/account/contact', enable: true },
      { label: 'Configuración', link: '/account/company', enable: true },
      { label: 'Actividades', link: '/account/activity', enable: true },
      // { label: 'Socios/F. Propios', link: '/account/partnersequity', enable: true },      { label: 'Actividades', link: '/account/activity', enable: true },
      { label: 'Factura', link: '/account/logo', enable: true },
      { label: 'Verifactu', link: '/account/verifactu', enable: true },
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  public onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}
